module.exports = __webpack_public_path__ + "img/facebook.0557804f.svg";